import { useEffect, useState, MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import brandLogo from '../../assets/images/logo.svg'
import { login } from 'services/coversationService';
import { eyeIcon, CloseEyeIcon } from '../../assets/icons';
import { useDispatch } from 'react-redux';
import { handleChatclose, handleLoader, setBotProduct, setIsNewConversation } from 'redux/counterSlice';
import { ToastContent, toast } from 'react-toastify';
import { getClientInfo } from 'services/paramsConfigService';
import { controlHandlerState, handleActive, handleIsUserHandler, handleRON, handleSwitch, resetQuestion, setSuggestionList } from 'redux/persistentSlice';
import CryptoJS from 'crypto-js';
import { setCurrLens } from 'redux/lensSlice';
import Cookies from 'js-cookie';


function Login() {
    const location2 = useLocation()
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [logoDes, setLogoDes] = useState(JSON.parse(localStorage.getItem('logos') as any));
    const [logo, setLogo] = useState<string>();
    // const [check, setCheck] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ username?: string, password?: string }>({});
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    console.log(window.location.search)
    useEffect(() => {
        dispatch(handleActive(""))
        dispatch(handleRON(''));
        dispatch(setCurrLens(""));
        dispatch(setBotProduct(""));
        dispatch(controlHandlerState(""));
        dispatch(setIsNewConversation("new"))
        dispatch(resetQuestion())
        dispatch(setSuggestionList([]));
        dispatch(handleChatclose(false));
        // localStorage.clear();
        localStorage.removeItem('access_token');
        localStorage.removeItem('announcements');
        // //localStorage.removeItem('clientName');
        localStorage.removeItem('default_label');
        localStorage.removeItem('default_questions');
        localStorage.removeItem('feature-flag');
        localStorage.removeItem('firstName');
        localStorage.removeItem('isLogged');
        localStorage.removeItem('lastActivity');
        localStorage.removeItem('lastName');
        localStorage.removeItem('loginTime');
        localStorage.removeItem('logos');
        localStorage.removeItem('permissions');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('username');
        localStorage.removeItem('lastBotQuestion');
        localStorage.removeItem('botId');

    }, [])

    const queryParams = new URLSearchParams(location2.search);
    const envParam = queryParams.get('env');

    const secretKey = 'RON__USER__LOGIN';
    const iv = 'BBBBBBBBBBBBBBBB';
    // Function to encrypt the password
    const encryptPassword = (password: string) => {
        // Replace 'your-secret-key' with your own secret key
        // Encrypt the password using AES encryption with the secret key
        // const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey).toString();
        // return encryptedPassword;
        const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.ECB
        });
        return encrypted.toString();
    };

    const getClient = async (env: any) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getClientInfo(env, false);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            localStorage.setItem("logos", JSON.stringify(result.logos_urls))
            setLogoDes(result.logos_urls);
            localStorage.setItem("clientName", result.client_name)
            localStorage.setItem("default_label", result.default_label)
            localStorage.setItem("default_questions", JSON.stringify(result.default_questions))
            dispatch(handleSwitch(false));
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    useEffect(() => {
        // This code will run whenever the URL changes
        if (envParam) {
            if (envParam === "Firstwatch") {
                getClient("InzaloEMS")
                localStorage.setItem("envParam", envParam);
            } else if (envParam === "demo") {
                getClient("InzaloEMS")
                localStorage.setItem("envParam", envParam);
            } else if (envParam === "AmSpec") {
                getClient("Amspec_clone")
                localStorage.setItem("envParam", 'Amspec_clone');
            } else {
                getClient(envParam)
                localStorage.setItem("envParam", envParam);
            }
        } else {
            getClient("shoptalk")
        }
    }, [envParam]);

    const handleValidation = () => {
        const hasCapitalLetters = /[A-Z]/.test(username);
        // Regular expression to check if email is in correct format
        const isValidFormat = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(username);

        const errors: any = {};
        if (username === "") {
            errors.username = 'Email is required';
        }
        if (username !== "" && hasCapitalLetters) {
            errors.username = 'Email must only contain lowercase letters';
        }
        if (username !== "" && !isValidFormat) {
            errors.username = 'Please enter a valid Email';
        }
        if (password === "") {
            errors.password = 'Password is required';
        }
        // if (check !== true) {
        //   errors.check = 'Please accept the Terms';
        // }
        return errors;
    }


    const registerTransfer = () => {
        navigate('/signup');
    }
    const forgotTransfer = () => {
        navigate('/forgot-password');
    }

    const handleLogin = async (e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>) => {
        e.preventDefault()
        // Perform validation
        const validationErrors = handleValidation();
        if (Object.keys(validationErrors).length === 0) {
            dispatch(handleLoader(true));
            try {
                const { result, error } = await login(username.trim(), encryptPassword(password.trim()));
                if (error) {
                    throw error
                }
                if (result?.error) {
                    throw result.error
                }
                if (result?.message) {
                    throw result.message
                }
                dispatch(handleLoader(false));
                const userHandler: any = Cookies.get(`handler_${username.trim()}`);
                if (userHandler !== undefined) {
                    dispatch(handleIsUserHandler(true));
                } else {
                    console.log("called here")
                    dispatch(handleIsUserHandler(false));
                }
                localStorage.setItem("access_token", result.auth_info.access_token)
                localStorage.setItem("refresh_token", result.auth_info.refresh_token)
                // let loginObj: any = {};
                // loginObj.featureFlag = result.user_info.feature,
                //     loginObj.permissions = result.user_info.permission,
                //     loginObj.announcements = result.user_info.notifications,
                //     loginObj.loginTime = new Date(),
                //     loginObj.username = result.user_info.email,
                //     loginObj.firstName = result.user_info.first_name,
                //     loginObj.lastName = result.user_info.last_name,
                //     loginObj.isLogged = "true",
                //     dispatch(handleLoginObject(loginObj));
                localStorage.setItem("username", result.user_info.email)
                localStorage.setItem("firstName", result.user_info.first_name);
                localStorage.setItem("lastName", result.user_info.last_name);
                localStorage.setItem("isLogged", "true")
                localStorage.setItem('feature-flag', JSON.stringify(result.user_info.feature));
                // dispatch(handlePermission(result.user_info.permission));
                localStorage.setItem('permissions', JSON.stringify(result.user_info.permission));
                localStorage.setItem('announcements', JSON.stringify(result.user_info.notifications));
                localStorage.setItem('loginTime', new Date() as any);
                navigate("/home")
            } catch (error) {
                dispatch(handleLoader(false));
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                });
                if (error === "User not found!") {
                    setPassword("");
                    setUsername("")
                } else if (error === "Your password is incorrect. Please try again") {
                    setPassword("");
                }
                console.log("error", error)
                // setCheck(false)
            }
        } else {
            dispatch(handleLoader(false));
            // Form is invalid; display validation errors
            setErrors(validationErrors);
        }
    }



    // const isBase64 = (data: any): Promise<boolean> => {
    //     return new Promise<boolean>((resolve) => {
    //         const base64Pattern = /^data:(.+);base64,(.*)$/;
    //         resolve(base64Pattern.test(data));
    //     });
    //     const imageBlob = new Blob([byteArray], { type: 'image/png' });
    //     const imageUrl = URL.createObjectURL(imageBlob);
    //     return imageUrl;
    // };

    useEffect(() => {
        if (logoDes !== null || logoDes !== "") {

            setLogo(`data:image/png;base64,${logoDes?.logo_home_page}`)
        } else {
            setLogo(brandLogo)

        }
    }, [logoDes])



    return (
        <div className="login-container">
            <div className='login-main'>
                {/* <div className='login-left'>
                    <div className='login-left_top'>
                        <img src={Group} className='left-image' alt="signup" />
                    </div>
                    <div className='login-left_bottom'></div>
                </div> */}
                <div className='login-right'>
                    <img src={logo} className='logo' style={{ width: '100px' }} alt="logo" />
                    <h3 className='login-header'>Sign in to your account</h3>
                    <form className='form'>
                        <div className='form-field2'>
                            <div>
                                <label className='form-label mr-1'>Email</label>
                                <span className="text-red-600">*</span>
                            </div>
                            <input
                                className="form-control"
                                type="email"
                                placeholder="Enter your Email"
                                value={username}
                                onChange={(e) => {
                                    delete errors.username;
                                    setUsername(e.target.value);
                                    // handleEmailChange(e);
                                }}
                                required
                            // autoComplete="new-password"
                            // pattern='/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
                            />
                            {errors.username && <span className="mt-2 text-danger">{errors.username}</span>}
                        </div>
                        <div className='form-field2'>
                            <div >
                                <label className='form-label mr-1'>Password</label>
                                <span className="text-red-600">*</span>
                            </div>
                            <div className='password position-relative'>
                                <input
                                    className="form-control"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter your Password"
                                    required
                                    value={password}
                                    onChange={(e) => {
                                        delete errors.password;
                                        setPassword(e.target.value);
                                    }}
                                // autoComplete="new-password"
                                />
                                <span className={`password-toggle position-absolute top-50 end-0 w-auto translate-middle`} onClick={() => setShowPassword(!showPassword)}>
                                    {!showPassword ? <img id='eyeicon' src={CloseEyeIcon} alt="eye-icon" /> :
                                        <img id='close-eye-icon' src={eyeIcon} alt="close-eye-icon" />
                                    }
                                </span>
                            </div>
                            {errors.password && <span className="mt-2 text-danger">{errors.password}</span>}
                        </div>
                        <div className="form-check right-align login-links">
                            {/* <input className="form-check-input" type="checkbox" id="flexCheckDefault" checked={check} onChange={handleCheckbox} />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                I Accept the <a>Terms</a>
              </label> */}
                            <p className='str-point' onClick={forgotTransfer}>Forgot Password?</p>
                        </div>
                        {/* {errors.check && <span className="mt-2 text-danger">{errors.check}</span>} */}
                        <button type='submit' className='btn btn-primary mt-4 w-100' onClick={handleLogin}>Continue</button>
                        {localStorage.getItem("clientName") !== 'Veedalifescience' &&
                            <p className='register-text text-center'>Don't have an account? <strong className='str-point' onClick={registerTransfer}>Sign Up</strong></p>
                        }
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;